import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { translate } from "../../../utils/translate";
import Select from 'react-select';
import { createAgent, createUser, editAgent, getUserList } from "../../../services/ApiService";
import country from "../../../utils/country";
import { goBackPage, promptMessage } from "../../../utils/functions";
import ListView from "../../components/ListView";
import { Col, Row } from "reactstrap";


const CreateAgent = (props) => {
    const lang = props.lang;
    const { type, slug } = useParams();
    const [queryParam, setQueryParam] = useState('');
    const [memberList, setMemberList] = useState([]);
    const [memberListFilter, setMemberListFilter] = useState([]);
    const [phoneCodeOptions, setPhoneCodeOptions] = useState(Object.keys(country).map((item, i) => { return { label: `(+${country[item].callingCode[0]}) ${country[item].name.common}`, value: `+${country[item].callingCode[0] ?? ""}` } }).filter((c) => c.value !== "" || c.value !== "+"));
    const history = useHistory();
    const [data, setData] = useState({
        fullName: "",
        email: "",
        username: "",
        phoneCode: "+60",
        phone: "",
        pin: "",
        confirmPin: "",
        agentCode: '',
    });
    const [error, setError] = useState({
        fullName: "",
        email: "",
        username: "",
        phoneCode: "",
        phone: "",
        confirmPin: "",
        agentCode: '',
    });
    // console.log(country);

    useEffect(() => {
        const query = new URLSearchParams(props.location.search).toString();
        setQueryParam(query)
    }, []);

    useEffect(() => {
        if (type === 'create') {
            setData({
                fullName: "",
                email: "",
                username: "",
                gender: "",
                phoneCode: "+60",
                phone: "",
                pin: "",
                confirmPin: "",
            })
        } else if (type === 'view') {
            if (!slug) {
                history.push('/agent');
                return;
            }
            getDetails(slug);
            getMemberList(slug);
        } else if (type === 'edit') {
            if (!slug) {
                history.push('/agent');
                return;
            }
            getDetails(slug);
            getMemberList(slug);
        }
    }, [])

    const listViewLayout = (list) => {
        return (
            <>
                <div className="card shadow d-flex flex-column agent-member-container-listview px-2">
                    {list.map(i => <>
                        <Row className="align-items-center px-0 mx-0 py-2">
                            <Col lg={10} md={10} sm={12} xs={12} className="mb-3 mb-md-0">
                                <Row>
                                    <Col lg={6} md={6} sm={12} xs={12} className="mb-1">
                                        <div className="text-black"><b>{translate(lang, "fullName")}</b>: {i.fullName}</div>
                                    </Col>
                                    <Col lg={6} md={6} sm={12} xs={12} className="mb-1">
                                        <div className="text-black d-block"><b>{translate(lang, "age")}</b>: {i.age}</div>
                                    </Col>
                                    <Col lg={6} md={6} sm={12} xs={12} className="mb-1">
                                        <div className="text-black d-block"><b>{translate(lang, "identityCard")}</b>: {i.identityCard && i.identityCard !== "" ? i.identityCard : "-"}</div>
                                    </Col>
                                    <Col lg={6} md={6} sm={12} xs={12} className="mb-1">
                                        <div className="text-black"><b>{translate(lang, "phone")}</b>: {i.phoneCode} {i.phone}</div>
                                    </Col>
                                    <Col lg={6} md={6} sm={12} xs={12} className="mb-1">
                                        <div className="text-black"><b>{translate(lang, "email")}</b>: {i.email && i.email !== "" ? i.email : "-"}</div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={2} md={2} sm={12} xs={12}>
                                <div className="d-flex w-100 justify-content-end">
                                    <Link to={`/member/view/${i.id}`} className="btn btn-sm btn-primary rounded-2 py-2" >{translate(lang, 'view')}</Link>
                                    {/* <button className="btn btn-sm btn-primary" onClick={() => createMember()}>{translate(lang, 'createMember')}</button> */}
                                </div>
                            </Col>
                        </Row>
                    </>)}
                </div>
            </>
        )
    }

    const onFilterInputChange = (input) => {
        // console.log('form', input);
        let temp;
        if (input !== "") {
            temp = memberList.filter(a => {
                let keys = Object.keys(a);
                let regex = new RegExp(input, "");
                if (keys.find(k => a[k] && a[k].toString().match(regex) && a[k].toString().match(regex).length > 0)) {
                    return a;
                }
                // console.log(a, keys);
                // keys.forEach(k => console.log(a[k], input))
                // return keys.forEach(k => {
                //     if (a[k]) {
                //         console.log(a[k].toString(), input.toString())
                //         if (a[k].toString().match(regex)) {
                //             return a
                //         }
                //     } else {
                //             console.log('no and skip next')
                //     }
                // })
                // return keys.forEach(k => a[k] && a[k].indexOf(input) > -1 ? a : false)
                // return passed ? a : false
            })
        } else {
            temp = memberList;
        }
        setMemberListFilter([...temp])
    }

    const getDetails = async (slug) => {
        let params = { id: slug };
        let res = await getUserList(params);
        if (res.status === 'success') {
            let data = res.data[0];
            setData({ ...data });
        } else {
            history.push('/agent');
        }
    }

    const getMemberList = async (slug) => {
        let params = { assignedAgent: slug, basic: 1 };
        let res = await getUserList(params);
        if (res.status === 'success') {
            let data = res.data;
            setMemberList([...data]);
            setMemberListFilter([...data]);
        } else {
            console.log(res);
        }
    }

    const onInputChange = (event) => {
        if (type === 'view') return;
        const { value, name } = event.target;
        let temp = data;
        temp[name] = value;
        setData({ ...temp });
    };

    const handleOptionSelected = (e, name) => {
        const { value } = e;
        const list = { ...data };
        list[name] = value;
        setData(list);
    }

    const submitForm = async () => {
        let check = true;
        let error = { fullName: "", phone: "", email: "", gender: "", pin: "", confirmPin: "", }
        if (!data.fullName) {
            check = false;
            error.fullName = translate(lang, "errorRequired");
        }
        if (!data.phoneCode) {
            check = false;
            error.phoneCode = translate(lang, "errorRequired");
        }
        if (!data.phone) {
            check = false;
            error.phone = translate(lang, "errorRequired");
        }
        if (data.phone.match(/\D+/)) {
            check = false;
            error.phone = translate(lang, "phoneInvalidFormat");
        }
        if (!data.email) {
            check = false;
            error.email = translate(lang, "errorRequired");
        }
        if (!data.agentCode) {
            check = false;
            error.agentCode = translate(lang, "errorRequired");
        }
        if (!data.email.match(/(\w+)@(\w+).(\w+)/gi)) {
            check = false;
            error.email = translate(lang, "emailInvalidFormat");
        }
        if (type === 'create') {
            if (!data.pin) {
                check = false;
                error.pin = translate(lang, "errorRequired");
            }
            if (!data.confirmPin) {
                check = false;
                error.confirmPin = translate(lang, "errorRequired");
            }
            if (data.pin && data.confirmPin) {
                if (data.pin !== data.confirmPin) {
                    check = false;
                    error.pin = translate(lang, "pinNotMatch")
                    error.confirmPin = translate(lang, "pinNotMatch")
                }
                if (data.pin.length < 6 || data.confirmPin.length < 6) {
                    check = false;
                    error.pin = translate(lang, "pinLengthTooShort")
                    error.confirmPin = translate(lang, "pinLengthTooShort")
                }
                if (data.pin.match(/\D+/) || data.confirmPin.match(/\D+/)) {
                    check = false;
                    error.pin = translate(lang, "pinOnlyNumber")
                    error.confirmPin = translate(lang, "pinOnlyNumber")
                }
            }
        }
        setError({ ...error });
        if (check) {
            if (type === 'create') {
                let res = await createAgent(data);
                if (res.status === 'success') {
                    promptMessage(lang, 'success', res.message);
                    resetForm();
                    history.push('/agent')
                } else {
                    promptMessage(lang, 'error', res.message);
                }
            } else if (type === 'edit') {
                let res = await editAgent(slug, data);
                if (res.status === 'success') {
                    promptMessage(lang, 'success', res.message);
                    resetForm();
                    history.push('/agent')
                } else {
                    promptMessage(lang, 'error', res.message);
                }
            }
        }
    }

    const resetForm = () => {
        setData({
            fullName: "",
            email: "",
            username: "",
            phoneCode: "",
            phone: "",
            pin: "",
            confirmPin: "",
        })
    }


    return (
        <>
            <Row className="px-0 mx-0">
                <Col lg={6} md={6} sm={6} xs={6} className="mb-3">
                    <div className="d-flex align-items-center w-100 mb-4">
                        <div onClick={() => goBackPage('/agent', queryParam)} className="cursor-pointer">
                            <div className="d-flex align-items-center">
                                <div className="back-btn">
                                    <i className="fas fa-chevron-left"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg={6} md={6} sm={6} xs={6} className="mb-3">
                    {type === 'view' ? (
                        <div className="d-flex w-100 justify-content-end">
                            <div onClick={() => goBackPage(`/agent/edit/${slug}`, queryParam)} className="btn btn-sm btn-primary rounded-2 py-2" >{translate(lang, 'edit')}</div>
                            {/* <button className="btn btn-sm btn-primary" onClick={() => createMember()}>{translate(lang, 'createMember')}</button> */}
                        </div>
                    ) : null}
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <div className="card shadow">
                                <div className="card-header">
                                    <h3 className="m-0">
                                        {translate(lang, (type === "view" ? "detailsAgent" : type === "edit" ? "editAgent" : "createAgent"))}
                                    </h3>
                                </div>
                                <div className="card-body col-12 d-flex flex-column">
                                    <div className="d-flex flex-column flex-md-row">
                                        <div className="form-group col-12 col-md-6 py-2 px-md-2">
                                            <label className="form-label required">{translate(lang, 'fullName')}</label>
                                            <input type="text" value={data.fullName} onChange={(e) => onInputChange(e)} name="fullName" className="form-control mb-0" disabled={type === 'view' ? true : false} placeholder={type === 'view' ? "" : translate(lang, 'placeholderEnterHere')} />
                                            <small className="text-danger">{error.fullName}</small>
                                        </div>
                                        <div className="form-group col-12 col-md-6 py-2 px-md-2">
                                            <label className="form-label required">{translate(lang, 'agentCode')}</label>
                                            <input type="text" value={data.agentCode} onChange={(e) => onInputChange(e)} name="agentCode" className="form-control mb-0" disabled={type === 'view' ? true : false} placeholder={type === 'view' ? "" : translate(lang, 'placeholderEnterHere')} />
                                            <small className="text-danger">{error.agentCode}</small>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column flex-md-row">
                                        <div className="form-group py-2 col-12 col-md-6 px-md-2">
                                            <label className="form-label required">{translate(lang, 'phoneCode')}</label>
                                            {/* <input type="text" value={data.phone} onChange={(e) => { setData({ ...data, phone: e.target.value }) }} className="form-control mb-0" disabled={type === 'view' ? true : false} placeholder={type === 'view' ? "" : translate(lang, 'placeholderEnterHere')} /> */}
                                            <Select
                                                className="form-control mb-0 px-0"
                                                value={phoneCodeOptions.filter((option) => {
                                                    return option.value === data.phoneCode
                                                }
                                                )}
                                                isDisabled={type === 'view' ? true : false}
                                                onChange={(e) => handleOptionSelected(e, "phoneCode")}
                                                options={phoneCodeOptions}
                                                placeholder={translate(lang, "placeholderChoose")}
                                                styles={{
                                                    control: (base, state) => ({
                                                        ...base,
                                                        height: "100%",
                                                        border: 0,
                                                        borderColor: "transparent",
                                                        boxShadow: "none",
                                                        "&:hover": {
                                                            borderColor: "transparent",
                                                            boxShadow: "none",
                                                        },
                                                        backgroundColor: "transparent",
                                                    }),
                                                    valueContainer: (base, state) => ({
                                                        ...base,
                                                        paddingLeft: "10px",
                                                        paddingRight: "10px",
                                                        borderColor: "transparent",
                                                    })
                                                }}
                                            />
                                            <small className="text-danger">{error.phoneCode}</small>
                                        </div>
                                        <div className="form-group py-2 col-12 col-md-6 px-md-2">
                                            <label className="form-label required">{translate(lang, 'phone')}</label>
                                            <input type="tel" value={data.phone} name="phone" onChange={(e) => onInputChange(e)} className="form-control mb-0" disabled={type === 'view' ? true : false} placeholder={type === 'view' ? "" : translate(lang, 'placeholderEnterHere')} />
                                            <small className="text-danger">{error.phone}</small>
                                        </div>
                                    </div>
                                    <div className="form-group py-2">
                                        <label className="form-label required">{translate(lang, 'email')}</label>
                                        <input type="email" value={data.email} name="email" onChange={(e) => onInputChange(e)} className="form-control mb-0" disabled={type === 'view' ? true : false} placeholder={type === 'view' ? "" : translate(lang, 'placeholderEnterHere')} />
                                        <small className="text-danger">{error.email}</small>
                                    </div>
                                    {type === 'create' ?
                                        <>
                                            <div className="d-flex flex-column flex-md-row">
                                                <div className="form-group col-12 col-md-6 py-2 px-md-2">
                                                    <label className="form-label required">{translate(lang, 'pin')}</label>
                                                    <input type="password" minLength={6} maxLength={6} accept="numeric" value={data.pin} name="pin" onChange={(e) => onInputChange(e)} className="form-control mb-0" disabled={type === 'view' ? true : false} placeholder={type === 'view' ? "" : translate(lang, 'placeholderEnterHere')} />
                                                    <small className="text-danger">{error.pin}</small>
                                                </div>
                                                <div className="form-group col-12 col-md-6 py-2 px-md-2">
                                                    <label className="form-label required">{translate(lang, 'confirmPin')}</label>
                                                    <input type="password" minLength={6} maxLength={6} accept="numeric" value={data.confirmPin} name="confirmPin" onChange={(e) => onInputChange(e)} className="form-control mb-0" disabled={type === 'view' ? true : false} placeholder={type === 'view' ? "" : translate(lang, 'placeholderEnterHere')} />
                                                    <small className="text-danger">{error.confirmPin}</small>
                                                </div>
                                            </div>
                                        </>
                                        : <></>
                                    }
                                </div>
                                <div className="card-footer">
                                    <div className="d-flex flex-row">
                                        <button type="button" hidden={type === 'view' ? true : false} className="btn btn-primary btn-sm rounded-2 py-2" onClick={() => submitForm()}>{translate(lang, `${type === 'edit' ? 'save' : type}`)}</button>
                                        <button type="button" className="btn btn-dark mx-2 btn-sm rounded-2 py-2" onClick={() => goBackPage('/agent', queryParam)}>{translate(lang, "back")}</button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        {type === "view" ?
                            (<Col lg={12} md={12} sm={12} xs={12}>
                                <div className="card shadow">
                                    <div className="card-header">
                                        <h3 className="m-0">
                                            {translate(lang, "assignedMemberList")}
                                        </h3>
                                    </div>
                                    <div className="card-body col-12 d-flex flex-column">
                                        {memberList.length > 0 ?
                                            <ListView data={memberListFilter} onFilterInputChange={(input) => onFilterInputChange(input)} layout={listViewLayout(memberListFilter)} search={true} lang={props.lang}></ListView>
                                            : <p>{translate(lang, "noMemberAssignedToThisAgent")}</p>
                                        }
                                    </div>
                                </div>
                            </Col>)
                            : <></>
                        }

                    </Row>
                </Col>
            </Row>
        </>
    )
}


const mapStateToProps = (state) => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
};


export default connect(mapStateToProps)(CreateAgent);